import React from 'react';
import InputContainer from '../../../citizen/AVPForms/layout/inputWrapper';
import { useForm } from "react-hook-form";
import ButtonWrapper from '../../../citizen/TCPForms/components/Button';
import { Col, Container, Row } from 'react-bootstrap';


const FilterForm = ({ onSubmit }) => {
  const { handleSubmit, control, reset } = useForm();
  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputContainer
                  control={control}
                  label="Application Number"
                  placeholder="Enter Application No"
                  name="applicationNumber"
                  type="textInput"
                  mandatory
                />
              </Col>
              <Col>
                <InputContainer
                  label="Mobile No"
                  control={control}
                  placeholder="Enter Mobile No"
                  name="mobileNumber"
                  type="textInput"
                  mandatory
                  maxLength={10}
                />
              </Col>

            </Row>
            <Row>
              <Col>
                <InputContainer
                  label="Form Type"
                  control={control}
                  placeholder="Select Form Type"
                  data={[
                    { value: 'Form LTP', label: 'Form LTP' },
                  ]}
                  name="formType"
                  type="selectInput"
                  mandatory
                />
              </Col>
              <Col>
                <InputContainer
                  label="License Number"
                  control={control}
                  placeholder="Enter License No"
                  name="licenseNumbers"
                  type="textInput"
                  mandatory
                />
              </Col>
            </Row>
          </Container>
        </div>
        <div className="footerContainer2">
          <div className="buttonWrapper" style={{ display: 'flex', gap: '8px' }}>
            <ButtonWrapper
              variant="contained"
              color="success"
              size="medium"
              label="Search"
              type="submit"
            />
            <ButtonWrapper
              variant="contained"
              color="error"
              size="medium"
              label="Reset"
              onClick={reset}
            />
          </div>
        </div>
      </form>
    </section>
  );
};

export default FilterForm;
